__turbopack_context__.v({
  "link": "tweet-replies-module__ktL-Xa__link",
  "replies": "tweet-replies-module__ktL-Xa__replies",
  "text": "tweet-replies-module__ktL-Xa__text",
});
